import React, {useEffect} from 'react';
import {useBlocker} from 'react-router-dom';
import ConfirmModal from '@/components/ConfirmModal';
import {useBlockerStore} from '@/stores/blocker';

function BlockModal(props: { text?: string; onCancel?: () => void; onConfirm?: () => void; }) {
  const [isBlocker, setBlocker, pendingAction, setPendingAction] =
    useBlockerStore(state => [state.isBlocker, state.setBlocker, state.pendingAction, state.setPendingAction]);

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isBlocker &&
      currentLocation.pathname !== nextLocation.pathname &&
      nextLocation.pathname !== '/login'
  );

  useEffect(() => {
    if (blocker.state === 'blocked' && !isBlocker) {
      blocker.reset();
    }
  }, [blocker, isBlocker]);

  const onClickConfirm = () => {
    pendingAction?.();
    setPendingAction(null);

    props.onConfirm?.();

    blocker.proceed?.();

    setBlocker(false);
  };

  const onClickCancel = () => {
    setPendingAction(null);
    props.onCancel?.();
    blocker.reset?.();
  };

  return (
    <ConfirmModal
      text={props.text || "画面遷移しますか？入力したデータは登録されません。"}
      confirmButtonText="OK"
      isShow={blocker.state === "blocked"}
      onConfirm={onClickConfirm}
      onCancel={onClickCancel}
    />
  );
}

export default BlockModal;
